import type { ConvoyTrackVertex } from './types';

/**
 * Preserve null when fix/accuracy were absent from the API; battery stays null when absent.
 */
export function normalizeTrackPointFacts(point: {
  battery?: number | null;
  fixTypeCode?: number | null;
  accuracyMeters?: number | null;
}): Pick<ConvoyTrackVertex, 'battery' | 'fixTypeCode' | 'accuracyMeters'> {
  return {
    battery: point.battery ?? null,
    fixTypeCode: point.fixTypeCode ?? null,
    accuracyMeters: point.accuracyMeters ?? null,
  };
}
